import { c as _c } from "react/compiler-runtime";
import { useAppearOnScroll } from "@/hooks/useAppearOnScroll";
import { useScrollToSection } from "@/hooks/useScrollToSection";
import { MenuToggle } from "@/layout/MenuToggle";
import { ThemeToggle } from "@/layout/ThemeToggle";
import { ROUTES } from "@/utils/constants";
import { cn } from "@/utils/helpers";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
const headerContent = {
  name: "Dimitar Daskalov",
  logoAlt: "Dimitar Daskalov Logo"
};
interface HeaderProps {
  isDrawerOpen?: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
  shouldShowDrawerToggle: boolean;
}
export const Header = t0 => {
  const $ = _c(28);
  const {
    isDrawerOpen: t1,
    setIsDrawerOpen,
    shouldShowDrawerToggle: t2
  } = t0;
  const isDrawerOpen = t1 === undefined ? false : t1;
  const shouldShowDrawerToggle = t2 === undefined ? true : t2;
  const router = useRouter();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      threshold: 50
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    shouldAppear: isScrolled
  } = useAppearOnScroll(t3);
  const {
    scrollToSection
  } = useScrollToSection();
  const shouldShowMenuToggle = shouldShowDrawerToggle && !!setIsDrawerOpen;
  let t4;
  if ($[1] !== router.pathname || $[2] !== scrollToSection) {
    t4 = e => {
      if (router.pathname === ROUTES.HOME) {
        e.preventDefault();
        scrollToSection("hero-section");
      }
    };
    $[1] = router.pathname;
    $[2] = scrollToSection;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleLogoClick = t4;
  const t5 = isDrawerOpen && "blur-sm pointer-events-none";
  let t6;
  if ($[4] !== t5) {
    t6 = cn("fixed top-4 left-4 right-4 z-100 max-w-7xl mx-auto", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = isScrolled && "glow";
  let t8;
  if ($[6] !== t7) {
    t8 = cn("relative rounded-full px-5 py-3 backdrop-blur-2xl bg-white/5 border border-white/10 transition-shadow duration-300", t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t10;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="relative w-8 h-8"><Image src="/logo.webp" alt={headerContent.logoAlt} fill={true} sizes="2rem" className="object-contain" /></div>;
    t10 = <span className="body-base font-semibold hidden md:block">{headerContent.name}</span>;
    $[8] = t10;
    $[9] = t9;
  } else {
    t10 = $[8];
    t9 = $[9];
  }
  let t11;
  if ($[10] !== handleLogoClick) {
    t11 = <Link href={ROUTES.HOME} onClick={handleLogoClick} className="flex items-center gap-4 h-full" aria-label="Go to homepage">{t9}{t10}</Link>;
    $[10] = handleLogoClick;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== isDrawerOpen || $[13] !== setIsDrawerOpen || $[14] !== shouldShowMenuToggle) {
    t12 = shouldShowMenuToggle && <MenuToggle isOpen={isDrawerOpen} onToggle={() => setIsDrawerOpen(!isDrawerOpen)} className="md:hidden" />;
    $[12] = isDrawerOpen;
    $[13] = setIsDrawerOpen;
    $[14] = shouldShowMenuToggle;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ThemeToggle />;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12) {
    t14 = <div className="flex items-center gap-2 h-full">{t12}{t13}</div>;
    $[17] = t12;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t11 || $[20] !== t14) {
    t15 = <div className="flex items-center justify-between relative z-10 h-12">{t11}{t14}</div>;
    $[19] = t11;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t15 || $[23] !== t8) {
    t16 = <div className={t8}>{t15}</div>;
    $[22] = t15;
    $[23] = t8;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16 || $[26] !== t6) {
    t17 = <header className={t6}>{t16}</header>;
    $[25] = t16;
    $[26] = t6;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
};